import React, { useEffect } from "react";
import moment from "moment";

export default function Print({
  selectedOrdersData,
  setIsPrint,
  setPrescriptionDataPrint,
}) {
  useEffect(() => {
    let prescriptionPrintData = [];
    const printContents = document.getElementById("printContent").innerHTML;

    selectedOrdersData.map((order, orderIndex) => {
      return (
        <div
          key={orderIndex}
          id={`order-${orderIndex}`}
          style={{
            padding: "10px",
            border: "1px solid #ccc",
          }}
        >
          {order.prescription.map((prescription) => {
            if (prescription.version === 1) {
              return (
                <div
                  key={`prescription-${orderIndex}`}
                  style={{ marginBottom: "10px" }}
                >
                  <p style={{ fontWeight: "bold" }}>
                    {prescription.prescription}
                  </p>
                </div>
              );
            } else {
              const parsedPrescriptions = JSON.parse(
                prescription.prescription
              ).prescription;
              return parsedPrescriptions.map(
                (prescriptionItem, prescriptionIndex) => {
                  const isRecommended =
                    prescriptionItem.showRecommendation === true;
                  return (
                    <div
                      key={`prescription-${orderIndex}-${prescriptionIndex}`}
                      style={{ marginBottom: "10px" }}
                    >
                      <p>
                        {prescriptionItem.Medicine}{" "}
                        {isRecommended && <span>(RECOMMENDED BY DOCTOR)</span>}
                      </p>
                    </div>
                  );
                }
              );
            }
          })}
        </div>
      );
    });

    if (setPrescriptionDataPrint && prescriptionPrintData.length > 0) {
      setPrescriptionDataPrint(prescriptionPrintData);
    } else {
      const newWin = window.open("_blank");
      newWin.document.write(printContents);
      newWin.print();
      newWin.close();
    }

    if (setIsPrint) setIsPrint(false);
  }, [selectedOrdersData]);

  return (
    <div id="printContent">
      {selectedOrdersData.map((orderData, orderIndex) => {
        return (
          <div
            key={`print-order-${orderIndex}`}
            style={{
              border: "1px solid #ccc",
              padding: "10px",
              marginBottom: "20px",
            }}
          >
            <p style={{ fontWeight: "bold", fontSize: "16px" }}>
              Order Display No: {orderData.order_display_id}
            </p>
            <p>Customer Name: {orderData.customer_name}</p>
            <p>
              Order Date: {moment(orderData.created_at).format("DD-MMM-YYYY")}
            </p>
            <p>Order Status: {orderData.status}</p>
            <p>Print Count: {orderData.print_count}</p>
          </div>
        );
      })}
    </div>
  );
}
